module.exports = __webpack_public_path__ + "03_hair_silver.bf3f23d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/03_hair_silver.png
// module id = jJVW
// module chunks = 0